var version = {
    "name":      "dativery",
    "buildDateCode": "20260617-160639",
    "buildDate": "Wed Jun 17 2026 16:06:39 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260617-160639",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;